import { DataTableHeader as Header } from "../types";

export interface DataTableResizeHandlerProps<T extends object> extends React.ComponentProps<"div"> {
  header: Header<T, unknown>;
}

export const DataTableResizeHandler = <T extends object>({ header }: DataTableResizeHandlerProps<T>) => {
  const resizeHandler = header.getResizeHandler();
  const isFirstColumn = header.id === "offloadIcon";
  const isResizable = header.column.getCanResize();

  if (!isResizable) return null;

  return (
    <div
      onMouseDown={resizeHandler}
      onTouchStart={resizeHandler}
      className="absolute right-0 top-0 h-full w-[2px] cursor-col-resize touch-none select-none bg-neutral-mid-gray hover:opacity-100"
    >
      {!isFirstColumn && <div className="absolute left-1/2 h-full w-[2px] -translate-x-1/2 bg-neutral-mid-gray" />}
    </div>
  );
};
